module.exports = __webpack_public_path__ + "static/media/tabs-explorer-disabled.93816f73.png";